import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import TopBar from '../topbar/topbar'
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import cachios from 'cachios'
import pr from '../assets/pr.jpg'
import home from '../assets/Home/home.png'
import togglearrow from '../assets/Home/togglearrow.png'
import pic from '../assets/pr.jpg';
import crumbarrow from '../assets/Home/right.png'
import Loader from 'react-loader'
import { List } from 'react-content-loader'
import Axios from 'axios';
import pageleft from '../assets/Home/pageleft.png'
import pagenoleft from '../assets/Home/pagenoleft.png'
import pagenoright from '../assets/Home/pagenoright.png'
import pageright from '../assets/Home/pageright.png'

class FacultyDetails extends Component {
    constructor(props) {
        super(props);
        console.log(props, 'props')
        this.state = {

            people: '',
            bioimg: '',
            pub: '',
            types: '',
            link: [],
            articletype: '',
            booktype: '',
            chaptype: '',
            conftype: '',
            thesistype: '',
            offsetarticles: 0,
            offsetbooks: 0,
            offsetbookChapters: 0,
            offsetconference: 0,
            offsetproject: 0,
            offsetmedias: 0,
            offsetworkingPaper: 0,
            tab: 0,
            refProject: [],
            ref1Project: [],
            projects: []
        }
    }

    setlink(id, i) {

        let array = this.state.link
        if (id !== '')
            cachios.get(BASE + 'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=id&filter[titleFilter][condition][value]=' + id, {
                ttl: 500 /* seconds */,
            })
                .then((data) => {
                    console.log(data, 'chk1')
                    array[i] = data.data.data[0]
                    this.setState({
                        link: array
                    })
                    console.log(array, 'now')

                })
        else {
            array.push('')
            this.setState({
                link: array
            })
            console.log(array, 'now')

        }
    }

    worktypes() {
        cachios.get(BASE + 'jsonapi/taxonomy_term/submit_for_work_types', {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'chk')
                data.data.data.map((value, ind) => {
                    if (value.attributes.name === 'Articles') {
                        this.setState({
                            articletype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Books') {
                        this.setState({
                            booktype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Book Chapters') {
                        this.setState({
                            chaptype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Thesis') {
                        this.setState({
                            thesistype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Conferences') {
                        this.setState({
                            conftype: value.id
                        })
                    }
                })
            })
        console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
    }
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }

    componentWillReceiveProps(nextProps) {

        console.log(nextProps.match.params.id, "nextProps")
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.setState({
                people: '',
                bioimg: ''
            })

            let url = window.location.href;
            let url_string = url;
            let urlStr = new URL(url_string);
            let c = urlStr.searchParams.get("key");
            let nid = urlStr.searchParams.get("nid");

            this.topFunction()
            this.worktypes()
            //API call

            // field publiction & field link
            cachios.get(BASE + 'jsonapi/node/faculty?include=field_selected_publication,field_designation,field_affliations&filter[drupal_internal__nid]=' + nid, {
                ttl: 500 /* seconds */,
            })
                .then((data) => {
                    let i, j, k;
                    console.log(data.data.included, 'noww')
                    if (data.data.included) {
                        this.setState({
                            pub: data.data.included
                        })
                        let array = []
                        for (i = 0; i < data.data.included.length; i++) {
                            array.push('')
                            this.setState({
                                link: array
                            })
                            if (data.data.included[i].relationships.field_reference.data != null) {
                                this.setlink(data.data.included[i].relationships.field_reference.data.id, i)
                                console.log(this.state.link, 'now')
                            }
                            else {
                                array[i] = '';
                                this.setState({
                                    link: array
                                })

                            }

                            // else{
                            //   let array=this.state.link
                            //   array.push('')
                            //   this.setState({
                            //     link:array
                            //   })
                            //   console.log(array,'now')

                            // }
                        }
                    }
                    cachios.get(BASE + 'jsonapi/node/faculty?include=field_image&filter[drupal_internal__nid]=' + nid, {
                        ttl: 500 /* seconds */,
                    })
                        .then((data) => {
                            console.log(data.data.data, 'xxx')
                            if (data.data.data.length === 0) {
                                window.location.href = '/404'
                            }
                            this.setState({
                                people: data.data.data[0].attributes,
                                bioimg: data.data.included ? BASE + data.data.included[0].attributes.uri.url : pr
                            })

                        })


                })
        }
    }


    setupBeforeUnloadListener = () => {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            return this.doSomethingBeforeUnload();
        });
    };

    doSomethingBeforeUnload = () => {
        localStorage.removeItem('related_faculty')
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.doSomethingBeforeUnload);
    }

    componentWillMount() {
        this.setupBeforeUnloadListener();

        if (localStorage.getItem('token'))
            this.checkexpiry()
        let related_faculty
        if (localStorage.getItem('related_faculty')) {
            related_faculty = localStorage.getItem('related_faculty')
            let related_faculty_head = localStorage.getItem('related_faculty_head')
            this.setState({
                related_faculty: related_faculty ? related_faculty !== "undefined" ? JSON.parse(related_faculty) : "" : "",
                related_faculty_head: related_faculty_head
            })

        }
        let url = window.location.href;
        let url_string = url;
        let urlStr = new URL(url_string);
        let c = urlStr.searchParams.get("key");
        let nid = urlStr.searchParams.get("nid");

        this.topFunction()
        this.worktypes()
        //API call

        // field publiction & field link

        cachios.get(BASE + 'jsonapi/node/faculty?include=field_selected_publication,field_programe,field_designation,field_affliations&filter[drupal_internal__nid]=' + nid, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                let i, j, k;
                console.log(data.data.included, 'noww')
                if (data.data.included) {
                    this.setState({
                        pub: data.data.included
                    })
                    let array = []
                    for (i = 0; i < data.data.included.length; i++) {
                        if (data.data.included[i].type === "paragraph--publications") {
                            array.push('')
                            this.setState({
                                link: array
                            })
                            if (data.data.included[i].relationships.field_reference.data != null) {
                                this.setlink(data.data.included[i].relationships.field_reference.data.id, i)
                                console.log(this.state.link, 'now')
                            }
                            else {
                                array[i] = '';
                                this.setState({
                                    link: array
                                })

                            }
                        }
                        else if (data.data.included[i].type === "taxonomy_term--programs") {
                            const program = {
                                "title": data.data.included[i].attributes.name,
                                "link": data.data.included[i].attributes.field_link ? data.data.included[i].attributes.field_link.uri : "",
                                "id": data.data.included[i].attributes.drupal_internal__tid
                            }
                            this.setState({
                                program: program
                            })
                        }
                        else if (data.data.included[i].type === "taxonomy_term--designation") {
                            this.setState({
                                designation: data.data.included[i].attributes.name
                            })
                        }
                        else if (data.data.included[i].type === "taxonomy_term--affiliations") {
                            const affiliation = {
                                "title": data.data.included[i].attributes.name,
                                "id": data.data.included[i].attributes.drupal_internal__tid
                            }
                            this.setState({
                                affiliation: affiliation
                            })
                        }
                        // else{
                        //   let array=this.state.link
                        //   array.push('')
                        //   this.setState({
                        //     link:array
                        //   })
                        //   console.log(array,'now')

                        // }
                    }
                }
                cachios.get(BASE + 'jsonapi/node/faculty?include=field_image&filter[drupal_internal__nid]=' + nid, {
                    ttl: 500 /* seconds */,
                })
                    .then((data) => {
                        console.log(data.data.data, 'xxx')
                        if (data.data.data.length === 0) {
                            window.location.href = '/404'
                        }
                        this.setState({
                            people: data.data.data[0].attributes,
                            faculty_id: data.data.data[0].id,
                            bioimg: data.data.included ? BASE + data.data.included[0].attributes.uri.url : pr,
                            authorid: data.data.data[0].relationships.field_author_faculty.data
                        }, () => {
                            this.loadPublications(data.data.data[0].relationships.field_author_faculty.data)
                            this.getMedia(data.data.data[0].id, 0)
                            this.getWorkingPapers(data.data.data[0].relationships.field_author_faculty.data, 0)

                        })
                        console.log('related_faculty', data.data.data[0].attributes.drupal_internal__nid)

                        // console.log('related_faculty', Number(JSON.parse(related_faculty)[2].nid[0]))



                    })


            })
    }
    async getWorkingPapers(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        Axios.get(`${BASE}jsonapi/node/working_papers_?&filter[people][condition][path]=field_authors.id${api}&page[offset]=${offset}&page[limit]=10`)
            .then(working => {
                console.log("working papers", working.data.data)
                this.setState({
                    workingPaper: working.data.data,
                    workingPapercount: working.data.meta ? working.data.meta.count : 0
                })
                if (working.data.links.next) {
                    this.setState({
                        nextworkingPaper: true
                    })
                }
                else
                    this.setState({
                        nextworkingPaper: false
                    })
                if (working.data.links.prev) {
                    this.setState({
                        prevworkingPaper: true
                    })
                }
                else
                    this.setState({
                        prevworkingPaper: false
                    })
            })
            .catch(err => {
                console.log("workingpaper error", err)
            })
    }
    async getMedia(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        Axios.get(`${BASE}jsonapi/node/media_coverage?filter[field_name_of_the_cis_staff.id]=${people}&page[offset]=${offset}&page[limit]=10&sort=-field_date_of_publication_media`)
            .then(media => {
                console.log("media coverage", media.data.data)
                this.setState({
                    medias: media.data.data,
                    mediascount: media.data.meta ? media.data.meta.count : 0
                })
                if (media.data.links.next) {
                    this.setState({
                        nextmedias: true
                    })
                }
                else
                    this.setState({
                        nextmedias: false
                    })
                if (media.data.links.prev) {
                    this.setState({
                        prevmedias: true
                    })
                }
                else
                    this.setState({
                        prevmedias: false
                    })
            })
    }
    async getBooks(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        console.log("people details api", api)
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_image,field_author&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&filter[people][condition][path]=field_author.id${api}&page[limit]=10&page[offset]=${offset}&sort=-field_year`)
            .then(book => {
                console.log("books in pubs", book.data)
                this.setState({
                    books: book.data.data,
                    bookscount: book.data.meta ? book.data.meta.count : 0
                })
                if (book.data.links.next) {
                    this.setState({
                        nextbooks: true
                    })
                }
                else
                    this.setState({
                        nextbooks: false
                    })
                if (book.data.links.prev) {
                    this.setState({
                        prevbooks: true
                    })
                }
                else
                    this.setState({
                        prevbooks: false
                    })
            })
            .catch((err) => {
                console.log("issue on getting books", err)
            })
    }
    async getArticles(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_image,field_author&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Articles&filter[people][condition][path]=field_author.id${api}&page[limit]=10&page[offset]=${offset}&sort=-field_year`)
            .then(book => {
                console.log("articles in pubs", book.data)
                this.setState({
                    articles: book.data.data,
                    articlescount: book.data.meta ? book.data.meta.count : 0
                })
                if (book.data.links.next) {
                    this.setState({
                        nextarticles: true
                    })
                }
                else
                    this.setState({
                        nextarticles: false
                    })

            })
            .catch((err) => {
                console.log("issue on getting articles", err)
            })
    }
    async getChapters(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_image,field_author&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Book Chapters&filter[people][condition][path]=field_author.id${api}&page[limit]=10&page[offset]=${offset}&sort=-field_year`)
            .then(book => {
                console.log("Book chapters in pubs", book.data)
                this.setState({
                    bookChapters: book.data.data,
                    bookChapterscount: book.data.meta ? book.data.meta.count : 0
                })
                if (book.data.links.next) {
                    this.setState({
                        nextbookChapters: true
                    })
                }
                else
                    this.setState({
                        nextbookChapters: false
                    })
            })
            .catch((err) => {
                console.log("issue on getting book chapters", err)
            })
    }
    async getConference(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][operator]=IN"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
        }
        Axios.get(`${BASE}jsonapi/node/submit_for_work?include=field_image,field_author&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Conferences&filter[people][condition][path]=field_author.id${api}&page[limit]=10&page[offset]=${offset}&sort=-field_year`)
            .then(book => {
                console.log("conference in pubs", book.data)
                this.setState({
                    conference: book.data.data,
                    conferencecount: book.data.meta ? book.data.meta.count : 0
                })
                if (book.data.links.next) {
                    this.setState({
                        nextconference: true
                    })
                }
                else
                    this.setState({
                        nextconference: false
                    })
            })
            .catch((err) => {
                console.log("issue on getting conference", err)
            })
    }
    leadProject = (api) => new Promise((resolve, reject) => {
        Axios.get(`${api}`)
            .then(res => {
                console.log("response in res lead", res.data)
                if (res.data.data.length == 0) {
                    resolve([])
                    this.setState({
                        stopped: true
                    })
                }
                else if (res.data.links.next) {
                    console.log("next link", res.data.links.next)
                    this.setState({
                        refProject: this.state.refProject.concat(res.data.data)
                    }, () => {
                        this.leadProject(res.data.links.next.href)
                    })
                }
                else {
                    console.log("stopped lead")
                    this.setState({
                        refProject: this.state.refProject.concat(res.data.data),
                        stopped: true
                    }, () => {
                        resolve(this.state.refProject)
                        console.log("resolving1")
                    })
                }
            })
            .catch(err => {
                reject(err)
                console.log("error in leadproject", err)
            })
    })
    otherProject = (api2) => new Promise((resolve, reject) => {
        Axios.get(`${api2}`)
            .then(res => {
                if (res.data.data.length == 0) {
                    resolve([])
                    this.setState({
                        stopped1: true
                    })
                }
                else if (res.data.links.next) {
                    console.log("next link", res.data.links.next)
                    this.setState({
                        refProject: this.state.ref1Project.concat(res.data.data)
                    }, () => {
                        this.otherProject(res.data.links.next.href)
                    })
                }
                else {
                    console.log("stopped other")
                    this.setState({
                        ref1Project: this.state.ref1Project.concat(res.data.data),
                        stopped1: true
                    }, () => {
                        resolve(this.state.ref1Project)
                        this.setState({
                            stopped1: true
                        })
                    })
                }
            })
            .catch(err => {
                console.log("error in leadproject", err)
                reject(err)
            })
    })
    async getProjects(people, offset) {
        let author = people.id, i, api = "&filter[people][condition][path]=field_lead_project__investigator.id&filter[people][condition][operator]=IN",
            api2 = "&filter[people1][condition][path]=field_projectinvestigator.id&filter[people1][condition][operator]=IN",
            pagination = "&page[offset]=0&page[limit]=50"
        console.log("people details", people)
        for (i = 0; i < people.length; i++) {
            let ui2 = `&filter[people1][condition][value][${i + 1}]=${people[i].id}`
            let ui = `&filter[people][condition][value][${i + 1}]=${people[i].id}`
            api += ui
            api2 += ui2
        }

        const project1 = this.leadProject(`${BASE}jsonapi/node/project?include=field_lead_project__investigator${api}${pagination}`)
        const project2 = this.otherProject(`${BASE}jsonapi/node/project?include=field_lead_project__investigator${api2}${pagination}`)
        console.log("final project promises", project1, project2)
        Promise.all([project1, project2])
            .then(res => {
                console.log("final project details", res)
            })
            .catch(err => {
                console.log("final project error", err)
            })
    }
    loadPublications(people) {
        if (people) {
            let author = people.id
            this.getBooks(people, 0)
            this.getArticles(people, 0)
            this.getChapters(people, 0)
            this.getConference(people, 0)
            this.getProjects(people, 0)

        }
    }
    handlePageClick(info) {
        console.log("action on click", info)
        window.scrollTo(0, 0)
        if (info === "prevbooks") {
            this.setState({
                offsetbooks: this.state.offsetbooks - 10,
                nextbooks: false
            }, () => {
                this.getBooks(this.state.authorid, this.state.offsetbooks)
            })
        }
        else if (info === "nextbooks") {
            this.setState({
                offsetbooks: this.state.offsetbooks + 10,
                nextbooks: false
            }, () => {
                this.getBooks(this.state.authorid, this.state.offsetbooks)
            })
        }
        if (info === "prevbookChapters") {
            this.setState({
                offsetbookChapters: this.state.offsetbookChapters - 10,
                nextbookChapters: false,
                tab: 2
            }, () => {
                this.getChapters(this.state.authorid, this.state.offsetbookChapters)
            })
        }
        else if (info === "nextbookChapters") {
            this.setState({
                offsetbookChapters: this.state.offsetbookChapters + 10,
                nextbookChapters: false,
                tab: 2
            }, () => {
                this.getChapters(this.state.authorid, this.state.offsetbookChapters)
            })
        }
        if (info === "prevarticles") {
            this.setState({
                offsetarticles: this.state.offsetarticles - 10,
                nextarticles: false

            }, () => {
                this.getArticles(this.state.authorid, this.state.offsetarticles)
            })
        }
        else if (info === "nextarticles") {
            this.setState({
                offsetarticles: this.state.offsetarticles + 10,
                nextarticles: false
            }, () => {
                this.getArticles(this.state.authorid, this.state.offsetarticles)
            })
        }
        if (info === "prevconferences") {
            this.setState({
                offsetconferences: this.state.offsetconferences - 10,
                nextconference: false
            }, () => {
                this.getConferences(this.state.authorid, this.state.offsetconferences)
            })
        }
        else if (info === "nextconferences") {
            this.setState({
                offsetconferences: this.state.offsetconferences + 10,
                nextconference: false
            }, () => {
                this.getConferences(this.state.authorid, this.state.offsetconferences)
            })
        }
        if (info === "prevproject") {
            this.setState({
                offsetproject: this.state.offsetproject - 10,
            })
        }
        else if (info === "nextproject") {
            let pages = Math.ceil(this.state.projectcount / 10),
                current_page = ((this.state.offsetproject + 10) / 10) + 1
            this.setState({
                offsetproject: this.state.offsetproject + 10,
                nextproject: pages == current_page ? false : true
            })
        }
        if (info === "prevmedias") {
            this.setState({
                offsetmedias: this.state.offsetmedias - 10,
                nextmedias: false
            }, () => {
                this.getMedia(this.state.faculty_id, this.state.offsetmedias)
            })
        }
        else if (info === "nextmedias") {
            this.setState({
                offsetmedias: this.state.offsetmedias + 10,
                nextmedias: false
            }, () => {
                this.getMedia(this.state.faculty_id, this.state.offsetmedias)
            })
        }
        if (info === "prevworkingPaper") {
            this.setState({
                offsetworkingPaper: this.state.offsetworkingPaper - 10,
                nextworkingPaper: false
            }, () => {
                this.getWorkingPapers(this.state.authorid, this.state.offsetworkingPaper)
            })
        }
        else if (info === "nextworkingPaper") {
            this.setState({
                offsetworkingPaper: this.state.offsetworkingPaper + 10,
                nextworkingPaper: false
            }, () => {
                this.getWorkingPapers(this.state.authorid, this.state.offsetworkingPaper)
            })
        }
    }
    goto(id, nid) {
        if (id === this.state.thesistype) {

            return '/theses_desc/' + nid
        }
        else if (id === this.state.booktype) {

            return '/book_desc/' + nid
        }
        else if (id === this.state.conftype) {

            return '/conf_desc/' + nid
        }
        else if (id === this.state.chaptype) {

            return '/book_chap_desc/' + nid
        }
        else if (id === this.state.articletype) {

            return '/article_desc/' + nid
        }

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.refProject !== prevState.refProject) {
            console.log("change in final project", this.state.refProject, this.state.ref1Project, "final out", this.state.projects)
        }
        if (this.state.stopped !== prevState.stopped || this.state.stopped1 !== prevState.stopped1) {
            if (this.state.stopped && this.state.stopped1) {
                console.log("both stopped")
                let final_data = this.state.refProject.concat(this.state.ref1Project)
                let sort_data = final_data.sort((a, b) => parseFloat(b.attributes.field_project_start_date) - parseFloat(a.attributes.field_project_start_date))
                this.setState({
                    projects: sort_data,
                    projectcount: sort_data.length,
                    nextproject: Math.ceil(sort_data.length / 10) > 1 ? true : false
                })
            }
        }
        if (this.state.articlescount !== prevState.articlescount ||
            this.state.bookscount !== prevState.bookscount || this.state.bookChapterscount !== prevState.bookChapterscount || this.state.conferencecount !== prevState.conferencecount
            || this.state.projects !== prevState.projects || this.state.mediascount !== prevState.mediascount || this.state.workingPapercount !== prevState.workingPapercount
        )
            if (this.state.articles && this.state.books && this.state.bookChapters && this.state.conference && this.state.projects && this.state.medias && this.state.workingPaper) {
                if (this.state.articles.length) {
                    this.setState({
                        tab: 3
                    })

                }
                else if (this.state.articles.length === 0 && this.state.books.length)
                    this.setState({
                        tab: 1
                    })
                else if (this.state.articles.length === 0 && this.state.books.length === 0 && this.state.bookChapters.length)
                    this.setState({
                        tab: 2
                    })
                else if (this.state.articles.length === 0 && this.state.books.length === 0 && this.state.bookChapters.length === 0 && this.state.conference.length)
                    this.setState({
                        tab: 6
                    })
                else if (this.state.articles.length === 0 && this.state.books.length === 0 && this.state.bookChapters.length === 0 && this.state.conference.length === 0 && this.state.projects.length)
                    this.setState({
                        tab: 5
                    })
                else if (this.state.articles.length === 0 && this.state.books.length === 0 && this.state.bookChapters.length === 0 && this.state.conference.length === 0 && this.state.projects.length === 0 && this.state.medias.length)
                    this.setState({
                        tab: 7
                    })
                else if (this.state.articles.length === 0 && this.state.books.length === 0 && this.state.bookChapters.length === 0 && this.state.conference.length === 0 && this.state.projects.length === 0 && this.state.medias.length === 0 && this.state.workingPaper.length)
                    this.setState({
                        tab: 4
                    })
                else {
                    this.setState({
                        tab: 0
                    })
                }
            }

    }


    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    render() {
        console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
        console.log(this.state.link, 'nowww')
        let url = window.location.href;
        let url_string = url;
        let urlStr = new URL(url_string);
        let c = urlStr.searchParams.get("key");
        let nid = urlStr.searchParams.get("nid");
        return (
            <div className='peoplewiki faculty-details'>
                <Header />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">CIS Staff</h1>
                </div>
                <div className='container'>
                    <div className='top-contents'>
                        <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /></Link><img className='rightarrow' src={crumbarrow} />Research<img className='rightarrow' src={crumbarrow} /><Link to='/research/faculty?faculty=Dean' className='gray-text'>CIS Staff</Link><img className='rightarrow' src={crumbarrow} />{this.state.people ? this.state.people.title.charAt(0).toUpperCase() + this.state.people.title.slice(1) : ""}</div>
                        {/* <TopBar data={'data1'} /> */}
                    </div>

                    {this.state.people ? <div className='cisFaculty-sub justify-content-between'>
                        <div className='cisFaculty-profile'>
                            {this.state.bioimg ? <img src={this.state.bioimg} className='cisFaculty-profileImage' />
                                : <img src={pic} className='cisFaculty-profileImage' />}
                            {this.state.people.field_h_index ? <div className='cisFaculty-stats'>
                                <div className='index text-left'>
                                    <div className='body-two'>H-Index (Google Scholar)</div>
                                </div>
                                <div className='score'>
                                    {this.state.people.field_h_index}
                                </div>
                            </div> : ""}
                            <div className='projectsToggle toggle-container' style={{ margin: "45px 0" }}>
                                <div className="toggle-bar-one">
                                    {this.state.articles ? this.state.articles.length ? <button className={this.state.tab === 3 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 3 })}>Articles {this.state.tab === 3 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.books ? this.state.books.length ? <button className={this.state.tab === 1 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 1 })}>Books {this.state.tab === 1 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.bookChapters ? this.state.bookChapters.length ? <button className={this.state.tab === 2 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 2 })}>Book Chapters {this.state.tab === 2 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.conference ? this.state.conference.length ? <button className={this.state.tab === 6 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 6 })}>Conference Papers {this.state.tab === 6 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.projects ? this.state.projects.length ? <button className={this.state.tab === 5 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 5 })}>Projects {this.state.tab === 5 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.medias ? this.state.medias.length ? <button className={this.state.tab === 7 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 7 })}>Other {this.state.tab === 7 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                    {this.state.workingPaper ? this.state.workingPaper.length ? <button className={this.state.tab === 4 ? 'main-blue-text body-two' : "gray-text body-two"} onClick={() => this.setState({ tab: 4 })}>Working Papers {this.state.tab === 4 ? <img className='toggle-arrow' src={togglearrow} /> : ""}</button> : "" : ""}
                                </div>
                            </div>
                        </div>
                        <div className='cisFaculty-profileContainer'>
                            <div className='d-flex  justify-content-between align-items-center '>
                                <p className='blue-text heading-three bold'>{this.state.people ? this.state.people.title.charAt(0).toUpperCase() + this.state.people.title.slice(1) : ""}</p>
                                {/* <a className='publications-btn'><p>Add Publications</p></a> */}
                            </div>
                            <p>{this.state.designation ? this.state.designation : ""}
                                {this.state.designation && this.state.program ? " of " : ""}
                                {this.state.program ? <a href={this.state.program.link} >{this.state.program.title}</a> : ""}
                            </p>

                            {this.state.affiliation ? <a target={"_blank"} href='https://www.hbku.edu.qa/en/cis'>{this.state.affiliation.title}</a> : ""}
                            <p label="bio" className="body-two faculty-details gray-text text-justify">
                                {this.state.people.body ? ReactHtmlParser(this.state.people.body.value) : ''}
                            </p>

                            <div className='cisFaculty_table' style={{ margin: "45px 0", width: "100%" }} >

                                <table className='newTable'>
                                    <tbody className=''>
                                        {this.state.tab == 1 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {this.state.books ? this.state.books.map(item => {
                                                    return (
                                                        <tr>
                                                            <td className='grantsCycle_title' ><Link to={`/publication/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                            <td className='grantsCycle_lead text-center'><p className="text-center">{item.attributes.field_year}</p></td>
                                                        </tr>
                                                    )
                                                }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 2 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.bookChapters ? this.state.bookChapters.map(item => {
                                                        return (
                                                            <tr>
                                                                <td className='grantsCycle_title' ><Link to={`/publication/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                                <td className='grantsCycle_lead text-center'><p className="text-center">{item.attributes.field_year}</p></td>
                                                            </tr>
                                                        )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 3 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.articles ? this.state.articles.map(item => {
                                                        return (
                                                            <tr>
                                                                <td className='grantsCycle_title' ><Link to={`/publication/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                                <td className='grantsCycle_lead text-center'><p className="text-center">{item.attributes.field_year}</p></td>
                                                            </tr>
                                                        )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 6 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.conference ? this.state.conference.map(item => {
                                                        return (
                                                            <tr>
                                                                <td className='grantsCycle_title' ><Link to={`/publication/${item.attributes.drupal_internal__nid}`}>{item.attributes.title}</Link></td>
                                                                <td className='grantsCycle_lead text-center'><p className="text-center">{item.attributes.field_year}</p></td>
                                                            </tr>
                                                        )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 5 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.projects ? this.state.projects.map((item, ind) => {
                                                        if (ind >= this.state.offsetproject && ind < (this.state.offsetproject + 10))
                                                            return (
                                                                <tr>
                                                                    <td className='grantsCycle_title' ><Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`}>{item.attributes.title ? item.attributes.title : ""}</Link></td>
                                                                    <td className='grantsCycle_lead text-center'><p className="text-center">{item.attributes.field_project_start_date ? new Date(item.attributes.field_project_start_date).getFullYear() : ""}</p></td>
                                                                </tr>
                                                            )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 7 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.medias ? this.state.medias.map(item => {
                                                        return (
                                                            <tr>
                                                                <td className='grantsCycle_title' ><p className="gray-text">{item.attributes.title ? item.attributes.title : ""}</p></td>
                                                                <td className='grantsCycle_lead text-center'><p className="gray-text text-center">{item.attributes.field_date_of_publication_media ? new Date(item.attributes.field_date_of_publication_media).getFullYear() : ""}</p></td>
                                                            </tr>
                                                        )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {this.state.tab == 4 ?
                                            <tbody className=''>
                                                <tr className='cisFaculty-head'>
                                                    <th className='tableHead_1 text-center'><p>Title</p></th>
                                                    <th className='tableHead_2 text-center'><p>Year</p></th>
                                                </tr>
                                                {
                                                    this.state.workingPaper ? this.state.workingPaper.map(item => {
                                                        return (
                                                            <tr>
                                                                <td className='grantsCycle_title' ><p className="gray-text">{item.attributes.title}</p></td>
                                                                <td className='grantsCycle_lead text-center'><p className="gray-text text-center">{item.attributes.field_date_of_publication_media ? new Date(item.attributes.field_date_of_publication_media).getFullYear() : ""}</p></td>
                                                            </tr>
                                                        )
                                                    }) : <p className="text-center"></p>}
                                            </tbody>
                                            : ""}
                                        {/* {
                                        this.state.tab === 1 ?
                                            books_data.map((item) => {
                                                return (
                                                    <tr className='projectDetails-row'>
                                                        <td className='grantsCycle_title' >{item.title}</td>
                                                        <td className='grantsCycle_lead text-center'>{i className="text-center"tem.year}</td>
                                                    </tr>
                                                )
                                            }) :
                                            this.state.tab === 2 ?
                                                books_data.map((item) => {
                                                    return (
                                                        <tr className='projectDetails-row'>
                                                            <td className='grantsCycle_title'>{item.title}</td>
                                                            <td className='grantsCycle_lead text-center'>{i className="text-center"tem.year}</td>
                                                        </tr>
                                                    )
                                                }) :
                                                this.state.tab === 3 ?
                                                    cycle_data1.map((item) => {
                                                        return (
                                                            <tr className='projectDetails-row'>
                                                                <td className='grantsCycle_title'>{item.title}</td>
                                                                <td className='grantsCycle_lead text-center'>{i className="text-center"tem.year}</td>
                                                            </tr>
                                                        )
                                                    }) :
                                                    this.state.tab === 4 ?
                                                        books_data.map((item) => {
                                                            return (
                                                                <tr className='projectDetails-row'>
                                                                    <td className='grantsCycle_title'>{item.title}</td>
                                                                    <td className='grantsCycle_lead text-center'>{i className="text-center"tem.year}</td>
                                                                </tr>
                                                            )
                                                        }) : ""

                                    } */}
                                    </tbody>
                                </table>
                                {/*pagination*/}
                                {this.state.tab === 1 && this.state.books ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetbooks === 0} onClick={() => this.handlePageClick('prevbooks')} className='prev'>{this.state.offsetbooks === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetbooks ? (this.state.offsetbooks / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.bookscount ? Math.ceil(this.state.bookscount / 10) : 1}</div> <button disabled={!this.state.nextbooks} onClick={() => this.handlePageClick('nextbooks')} className='next'>{this.state.nextbooks ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 2 && this.state.bookChapters ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetbookChapters === 0} onClick={() => this.handlePageClick('prevbookChapters')} className='prev'>{this.state.offsetbookChapters === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetbookChapters ? (this.state.offsetbookChapters / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.bookChapterscount ? Math.ceil(this.state.bookChapterscount / 10) : 1}</div> <button disabled={!this.state.nextbookChapters} onClick={() => this.handlePageClick('nextbookChapters')} className='next'>{this.state.nextbookChapters ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 3 && this.state.articles ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetarticles === 0} onClick={() => this.handlePageClick('prevarticles')} className='prev'>{this.state.offsetarticles === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetarticles ? (this.state.offsetarticles / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.articlescount ? Math.ceil(this.state.articlescount / 10) : 1}</div> <button disabled={!this.state.nextarticles} onClick={() => this.handlePageClick('nextarticles')} className='next'>{this.state.nextarticles ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 6 && this.state.conference ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetconference === 0} onClick={() => this.handlePageClick('prevconference')} className='prev'>{this.state.offsetconference === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetconference ? (this.state.offsetconference / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.conferencecount ? Math.ceil(this.state.conferencecount / 10) : 1}</div> <button disabled={!this.state.nextconference} onClick={() => this.handlePageClick('nextconference')} className='next'>{this.state.nextconference ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 5 && this.state.projects ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetproject === 0} onClick={() => this.handlePageClick('prevproject')} className='prev'>{this.state.offsetproject === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetproject ? (this.state.offsetproject / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.projectcount ? Math.ceil(this.state.projectcount / 10) : 1}</div> <button disabled={!this.state.nextproject} onClick={() => this.handlePageClick('nextproject')} className='next'>{this.state.nextproject ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 7 && this.state.medias ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetmedias === 0} onClick={() => this.handlePageClick('prevmedias')} className='prev'>{this.state.offsetmedias === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetmedias ? (this.state.offsetmedias / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.mediascount ? Math.ceil(this.state.mediascount / 10) : 1}</div> <button disabled={!this.state.nextmedias} onClick={() => this.handlePageClick('nextmedias')} className='next'>{this.state.nextmedias ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                                {this.state.tab === 4 && this.state.workingPaper ?
                                    <div className='new-pagination'>
                                        <button disabled={this.state.offsetworkingPaper === 0} onClick={() => this.handlePageClick('prevworkingPaper')} className='prev'>{this.state.offsetworkingPaper === 0 ? <img src={pagenoleft} /> : <img src={pageleft} />}</button>   <div className='pageno'>{this.state.offsetworkingPaper ? (this.state.offsetworkingPaper / 10) + 1 : 1}</div><span className='pagination-of'> of </span><div className='total'>{this.state.workingPapercount ? Math.ceil(this.state.workingPapercount / 10) : 1}</div> <button disabled={!this.state.nextworkingPaper} onClick={() => this.handlePageClick('nextworkingPaper')} className='next'>{this.state.nextworkingPaper ? <img src={pageright} /> : <img src={pagenoright} />}</button>

                                    </div>
                                    : ""}
                            </div>
                        </div>
                    </div> : <div className="container" style={{ minHeight: "70vh" }}> <Loader color="#165e84" loaded={false} className="spinner" /></div>}
                </div>
                <Footer />
            </div >
        )
    }
}


export default FacultyDetails;
